module.exports = __webpack_public_path__ + "img/wechat.14c668d7.png";